<script>
  import DoNotContactForm from './do-no-contact';

  export default {
    extends: DoNotContactForm,
  }
</script>
